import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, Slide, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import PostDescription from '../PostDescription';
import CardHeader from '../CardHeader';
import InteractionsBox from '../../Posts/Shared/InteractionsBox';
import { postPath } from '../../../Utils/routes';
import { cloudinaryImageUrl, CloudinaryConfig } from '../../../Services/Cloudinary';

function PostCarouselItem({ post, space, onClickVote, defaultView }: any) {
  const {
    included: { author },
  } = post;
  const [visible, setVisible] = useState(true);

  const trackingProps = {
    Origin: 'Carousel',
    'Default View': defaultView,
  };

  useEffect(() => {
    setVisible(true);
  }, [post]);

  return (
    <Slide in={visible} direction="up" mountOnEnter unmountOnExit>
      <Card elevation={0} sx={{ width: '100%' }}>
        <CardActionArea
          to={postPath(space.slug, post.slug)}
          component={Link}
          underline="none"
          sx={{ paddingX: { xs: 2, sm: 0 } }}
        >
          <Stack
            spacing={3}
            sx={{
              px: { xs: 0, sm: 3 },
              py: 2,
            }}
          >
            <CardHeader
              profilePictureUrl={cloudinaryImageUrl(
                author.picture?.s3_key,
                CloudinaryConfig.AVATAR_30,
                author.picture?.title,
              )}
              initials={author.initials}
              fullName={author.full_name}
              alt={author.full_name}
              date={post.published_at}
              avatarSize={30}
              placeholderType="user"
            />

            <Typography variant="h6" component="h2">
              {post.title}
            </Typography>

            <Box sx={{ flex: 1, minHeight: 200 }}>
              <PostDescription content={post.content} readMore />
            </Box>

            <InteractionsBox
              post={post}
              space={space}
              direction="row"
              ctaVariant="outlined"
              onClickVote={onClickVote}
              trackingProps={trackingProps}
              onlyPrimaryActions
              size="small"
            />
          </Stack>
        </CardActionArea>
      </Card>
    </Slide>
  );
}

export default PostCarouselItem;
